import classNames from 'classnames';

function Container({ children, className }) {
  return <div className={classNames(className, 'container mx-auto px-4 sm:px-6 lg:px-8')}>{children}</div>;
}
export default Container;
